module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item8-08174a7fc7c99fbdee4167ed8427960a.svg";